var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChevronLeft = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.601 4.399a.85.85 0 0 1 0 1.202L9.202 12l6.399 6.399a.85.85 0 1 1-1.202 1.202l-7-7a.85.85 0 0 1 0-1.202l7-7a.85.85 0 0 1 1.202 0",
  clipRule: "evenodd"
})));
export default SvgChevronLeft;